import React, { Component } from 'react';
import { LineChart , AreaChart , XAxis , YAxis , Legend , Line , Tooltip , Area} from 'recharts'

class CustomLineChart extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    static defaultProps = {
        data : [
            {
              "Period": "Page A",
              "Sales": 4000
            }
            ,
            {
              "Period": "Page B",
              "Sales": 4000
            }
        ]
    }

    render() { 
        return (  
             this.props.type === 'area' ? 
             <AreaChart width={900} height={440} data={this.props.data}
                margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>   
                <XAxis dataKey="Period" />
                <YAxis tickFormatter={(v)=> "Rs."+ v} />
                <Tooltip />
                {/* <Legend  /> */}
                <Area type="monotone" dataKey="Sales" stroke="#8884d8" />
                {/* <Line type="monotone" dataKey="value2" stroke="#82ca9d" /> */}
              </AreaChart>
             :                             
              <LineChart width={900} height={440} data={this.props.data}
                margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>   
                <XAxis dataKey="Period" />
                <YAxis tickFormatter={(v)=> "Rs."+ v} />
                <Tooltip />
                {/* <Legend  /> */}
                <Line type="monotone" dataKey="Sales" stroke="#8884d8" />
                {/* <Line type="monotone" dataKey="value2" stroke="#82ca9d" /> */}
              </LineChart>
          );
    }
}
 
export default CustomLineChart;